import React, { useEffect } from "react";
import InfoSection from "@components/pages/info/info_section";
import { Form, FormControl, FormLabel } from "react-bootstrap";
import { useRouter } from "next/router";
import { useState } from "react";
import { FlexContainer } from "@components/ui/flex_container";
import { fetcherNew1819 } from "@utils/fetcherNew1819";

function ServiceNumber() {
    const router = useRouter();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [router.pathname]);

    const [formName, setFormName] = useState("");
    const [formEmail, setFormEmail] = useState("");
    const [formPhone, setFormPhone] = useState("");
    const [formMessage, setFormMessage] = useState("");
    const [isSending, setIsSending] = useState(false);
    const [successfullySent, setSuccessfullySent] = useState(false);

    var defaultMessage = "";
    if (formMessage.length === 0 && router.query.leit) {
        defaultMessage = `Ekkert fannst með leitarorðinu "${router.query.leit}".\nÁbending:\n`;
        setFormMessage(defaultMessage);
    }

    if (successfullySent) {
        return (
            <InfoSection title="Hafa samband">
                <FlexContainer
                    column
                    justifyContent="center"
                    alignItems="center"
                    className="text-center pt-3 pb-3"
                >
                    <img
                        className="success-icon"
                        style={{ width: 50, marginBottom: 20 }}
                        src={"/img/circled-checkmark.svg"}
                    />
                    <div>Þakka þér fyrir að hafa samband.</div>

                    <div>Við munum svara fyrirspurninni við fyrsta tækifæri.</div>
                </FlexContainer>
            </InfoSection>
        );
    }

    return (
        <InfoSection title="Hafa samband">
            <Form>
                <FormLabel htmlFor="nameInput">Nafn *</FormLabel>
                <FormControl
                    value={formName}
                    onChange={(e) => setFormName(e.target.value)}
                    id="nameInput"
                    type="text"
                    placeholder="Nafn"
                    className="mb-3"
                    required
                />
                <FormLabel htmlFor="nameInput">Netfang *</FormLabel>
                <FormControl
                    value={formEmail}
                    onChange={(e) => setFormEmail(e.target.value)}
                    id="nameInput"
                    type="text"
                    placeholder="Netfang"
                    className="mb-3"
                    required
                />
                <FormLabel htmlFor="nameInput">Símanúmer</FormLabel>
                <FormControl
                    value={formPhone}
                    onChange={(e) => setFormPhone(e.target.value)}
                    id="nameInput"
                    type="text"
                    placeholder="Símanúmer"
                    className="mb-3"
                />
                <FormLabel htmlFor="nameInput">Skilaboð *</FormLabel>
                <FormControl
                    value={formMessage}
                    onChange={(e) => setFormMessage(e.target.value)}
                    as="textarea"
                    rows="5"
                    id="nameInput"
                    type="textarea"
                    placeholder="Hvað liggur þér á hjarta?"
                    className="mb-3"
                    required
                    style={{ minHeight: 400 }}
                />
                <FormControl
                    onClick={(e) => {
                        e.preventDefault();
                        if (formName.length == 0) return;
                        if (formEmail.length == 0) return;
                        if (formMessage.length == 0) return;
                        setIsSending(true);

                        var formBody = [];

                        var details = {
                            name: formName,
                            netfang: formEmail,
                            phone: formPhone,
                            message: formMessage,
                        };
                        for (var property in details) {
                            if (!details[property]) {
                                continue;
                            }
                            var encodedKey = encodeURIComponent(property);
                            var encodedValue = encodeURIComponent(details[property]);

                            formBody.push(encodedKey + "=" + encodedValue);
                        }
                        formBody = formBody.join("&");

                        fetcherNew1819("1819/mail/contact-us", "POST", {
                            send_to: "1819@1819.is",
                            subject: "Ný skilaboð frá 1819.is",
                            name: formName,
                            phone: formPhone,
                            email: formEmail,
                            description: formMessage,
                        })
                            .then(() => {
                                setIsSending(false);
                                setSuccessfullySent(true);
                            })
                            .catch((e) => {
                                console.log(e);
                                setIsSending(false);
                                setSuccessfullySent(false);
                            });
                    }}
                    type="submit"
                    value="Senda"
                    disabled={
                        isSending ||
                        !(formName.length != 0 && formEmail.length != 0 && formMessage.length != 0)
                    }
                    className="btn btn-primary mb-2"
                />
            </Form>
        </InfoSection>
    );
}
export default ServiceNumber;
